// test1240
(1240 && 0);
